import React from 'react'

function Sponsors() {
  return (
    <div>
      
    </div>
  )
}

export default Sponsors
